import { BUTTON_TYPE, SIZE } from '@app/constants'

import type { LntButtonProps } from '@app/components/base/Button/types'

export const defaultAcceptButton: LntButtonProps = {
  type: BUTTON_TYPE.secondary,
  size: SIZE.small,
  htmlType: 'submit'
}

export const defaultResetButton: LntButtonProps = {
  type: BUTTON_TYPE.text,
  size: SIZE.small
}
